import { render, staticRenderFns } from "./bind_phone.vue?vue&type=template&id=ad033cd8&scoped=true"
import script from "./bind_phone.vue?vue&type=script&lang=js"
export * from "./bind_phone.vue?vue&type=script&lang=js"
import style0 from "./bind_phone.vue?vue&type=style&index=0&id=ad033cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad033cd8",
  null
  
)

export default component.exports